<template>
  <div class="map-wrapper__filter">
    <div class="map-wrapper__filter__options">
      <label
        ><a href="#" @click.prevent="expanded = !expanded" class="has-icon map-wrapper__filter__toggle-button"
          ><Pin /> Public observations</a
        ></label
      >
      <label class="custom-radio-button">
        <input type="checkbox" value="recent" :checked="showRecentPublicObs === true" @change="showRecent(true)" />
        <span></span> Past 7 days
      </label>
      <label class="custom-radio-button">
        <input type="checkbox" value="all" :checked="showRecentPublicObs === false" @change="showRecent(false)" />
        <span></span> Whole season
      </label>
    </div>
    <div :class="['map-wrapper__filter__help', { collapsed: !expanded }]">
      <label class="has-icon "> <Pin /> Recent avalanche (7 days) </label>
      <label class="has-icon "> <Pin class="older-avalanche" /> Older avalanche </label>
      <label class="has-icon "> <Pin class="recent-snowpack" /> Recent snowpack (7 days) </label>
      <label class="has-icon "> <Pin class="older-snowpack" /> Older snowpack </label>
    </div>
  </div>
</template>

<script>
import Pin from "../public-marker/Pin";
import { mapState } from "vuex";

export default {
  name: "MapFilter",
  components: {
    Pin
  },

  data() {
    return {
      expanded: false
    };
  },

  computed: {
    ...mapState({
      showRecentPublicObs: state => state.showRecentPublicObs
    })
  },

  methods: {
    showRecent(show) {
      this.$store.commit("SET_SHOW_RECENT_PUBLIC_OBS", show);
    }
  }
};
</script>
